import moment from 'moment';

export function dateFormatterBasedOnTimeZone(date, timeZone, format: string = 'YYYY-MM-DD HH:mm'): Date {
    return new Date(moment(date).clone().utcOffset(timeZone, false).format(format));
}
